import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import './App.css';
import store from "./store";
import {Provider} from "react-redux";
import Routes from './routes/index'


function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes/>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
